import { IconWrapper } from '../runtime';
export default IconWrapper('ksheet_format_s', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z",
      "fill": "#1EA623"
    }
  }), h("path", {
    "attrs": {
      "d": "M0 14H16C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14Z",
      "fill": "#148F19"
    }
  }), h("path", {
    "attrs": {
      "d": "M8 14H16C16 15.1046 15.1046 16 14 16H8V14Z",
      "fill": "#2ABF30"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M3 3V11H13V3H3ZM7.25 4.5H4.5V6.25H7.25V4.5ZM8.75 4.5V6.25H11.5V4.5H8.75ZM7.25 7.75H4.5V9.5H7.25V7.75ZM8.75 9.5V7.75H11.5V9.5H8.75Z",
      "fill": "white"
    }
  })]);
});